import { apiClient } from './apiClient';
import { isDevRosterAuthRequired } from '../config/devRosterAuth';
import type { UserCompanyApiRow } from '../utils/mapUserCompaniesFromApi';

/**
 * Load company_instances for the logged-in user, including companies.kryspace_slug.
 * Authenticated route first; dev roster fallback when JWT path fails in local dev.
 */
export async function fetchUserCompanyRows(userId: string): Promise<UserCompanyApiRow[]> {
  try {
    const response = await apiClient.get<UserCompanyApiRow[]>(`/users/${userId}/companies`);
    return response.data ?? [];
  } catch (primaryError) {
    const useDevFallback =
      process.env.NODE_ENV === 'development' &&
      (isDevRosterAuthRequired() || process.env.REACT_APP_DEV_ROSTER_AUTH === 'true');
    if (!useDevFallback) {
      throw primaryError;
    }
    const devResponse = await apiClient.get<UserCompanyApiRow[]>(
      `/dev/users/${userId}/companies`
    );
    return devResponse.data ?? [];
  }
}
